import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StringLiteralLike } from 'typescript';
import { TimeoutService } from '../../time-out.service';

@Component({
  selector: 'slt-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef <DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public message: StringLiteralLike,
    private timeOut: TimeoutService) {
      
     }

  ngOnInit(): void {
    
  }

  clickCancelar(): void{
    this.dialogRef.close();
  }

}
